import * as React from 'react'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import { ListItemTextContents } from './ListItemTextContents'

export function DraftLeadTypeTooltipContents() {
  return (
    <List>
      <ListItem alignItems="flex-start">
        <ListItemTextContents
          title="Web"
          description="Lead captured from a web form submission"
        />
      </ListItem>
      <ListItem alignItems="flex-start">
        <ListItemTextContents
          title="Phone"
          description="Lead originated from a tracked phone call"
        />
      </ListItem>
      <ListItem alignItems="flex-start">
        <ListItemTextContents
          title="Mobile"
          description="Submitted lead from the mobile app"
        />
      </ListItem>
      <ListItem alignItems="flex-start">
        <ListItemTextContents
          title="Manual"
          description="Lead was manually entered and submitted from an
          external source"
        />
      </ListItem>
      <ListItem alignItems="flex-start">
        <ListItemTextContents
          title="ServiceBot"
          description="Lead originated from Service Bot"
        />
      </ListItem>
      <ListItem alignItems="flex-start">
        <ListItemTextContents
          title="Import"
          description="Lead originated from an imported template"
        />
      </ListItem>
    </List>
  )
}
